import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';
import { transformToSelectOptions } from '~/utils/common';

import { API_ENDPOINT } from '~/constants';

import { deliveryAgencyKeys } from './keys';

import type {
  TypeDeliveryAgencyTrackingFilterOptions,
  TypeGetShippingLabelsSearchConditionsResponse,
} from '~/types/delivery-agency.types';

/**
 * [운송장 관리] 검색 필터 코드 조회 API
 */
export const fetchShippingLabelsSearchConditions = async (): Promise<
  TypeGetShippingLabelsSearchConditionsResponse['data']
> => {
  const { data } = await axiosInstance.get<TypeGetShippingLabelsSearchConditionsResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.GET_SHIPPING_LABELS_CODES
  );
  return data.data;
};

/**
 * [운송장 관리] 검색 필터 코드 조회 Query Hook
 */
export const useGetShippingLabelsSearchConditionsQuery = (options?: { enabled?: boolean; silent?: boolean }) => {
  return useQuery({
    queryKey: deliveryAgencyKeys.shippingLabelsSearchConditions(),
    queryFn: fetchShippingLabelsSearchConditions,
    staleTime: 1000 * 60 * 30,
    enabled: options?.enabled ?? true,
    meta: { silent: options?.silent },
    select: (data): TypeDeliveryAgencyTrackingFilterOptions => ({
      searchKeywordTypes: transformToSelectOptions(data.searchKeywordTypes, 'code', 'description'),
      trackingStatuses: transformToSelectOptions(data.shippingLabelStatuses, 'code', 'description'),
      deliveryFailureReasonCategories: transformToSelectOptions(
        data.deliveryFailureReasonCategories,
        'code',
        'description'
      ),
      deliveryTypes: transformToSelectOptions(data.deliveryTypes, 'code', 'description'),
      courierCodes: transformToSelectOptions(data.courierCodes, 'code', 'description'),
    }),
  });
};
